import { useFindingOnAsset } from "~/pages/findings/FindingOnAsset/hooks";
import { CheckQueries } from "~/pages/space/security/components/Check/CheckQueries";
import { isCheckFinding } from "~/pages/findings/FindingOnAsset/utils";
import React from "react";
import { CheckOnAssetFindingNode } from "~/pages/findings/FindingOnAsset/types";

export const Queries = () => {
  const { checkData, finding } = useFindingOnAsset();
  const policyId = (
    finding as CheckOnAssetFindingNode
  )?.relatedPolicies?.[0]?.mrn
    ?.split("/")
    ?.pop();

  if (
    (!checkData?.mql && checkData?.properties?.length === 0) ||
    !isCheckFinding(finding)
  )
    return;

  return (
    <CheckQueries
      properties={checkData?.properties || []}
      mql={checkData?.mql}
      policyId={policyId}
    />
  );
};
